/* eslint-disable react/prop-types */
import React from 'react';
import { BarChart, Bar, XAxis, YAxis } from 'recharts';

class Chart00 extends React.Component {
  render() {
    return (
      <BarChart
        width={218}
        height={30}
        // eslint-disable-next-line react/prop-types
        data={this.props.data}
        margin={{ top: 0, right: 5, left: 5, bottom: 0 }}
        layout="vertical"
      >
        <XAxis type="number" hide={true} />
        <YAxis dataKey="name" type="category" hide={true} />
        <Bar dataKey="pv" stackId="a" fill="#DADBDB" />
        <Bar dataKey="uv" stackId="a" fill={this.props.fillColor} />
      </BarChart>
    );
  }
}

export default Chart00;
